type ErrorMessageProps = React.ComponentPropsWithoutRef<'p'>

export const ErrorMessage = (props: ErrorMessageProps): JSX.Element => (
  <p className='text-sm font-light text-red-500 ml-1' {...props}>
    {props.children}
  </p>
)
